import React, { useCallback, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import Pagination from "../../../components/pagination/Pagination";
import EyesIcon from "../../../assets/icons/EyesIcon";
import { Download } from "../../../assets/icons/Download";
import Modal from "../../../components/modal/Modal";
import Card from "../../../components/card/Card";
import { t } from "i18next";
import { getFiles } from "../../../services/FileService";
import { roles } from "../../../constants/roles";
import { useAuth } from "../../../hooks/useAuth";
import { toast } from "react-toastify";
import { UpdateFile } from "../register/components/updateFile/UpdateFile";
import { ShowFile } from "../register/components/showFile/ShowFile";

const UserPayments = () => {
  const { user } = useAuth().user;
  const [files, setFiles] = useState(null);
  const [fileSelected, setFileSelected] = useState();
  const [toggleUpdateFile, setToggleUpdateFile] = useState(false);
  const [showFile, setShowFile] = useState(false);

  const requestFile = useMemo(() => {
    return [
      {
        id: 1,
        name: "Acta de nacimiento.",
        file: "",
        status: "no enviado",
        documentType: "acta_nacimiento",
        meta: {},
      },
      {
        id: 2,
        name: "Pasaporte o Licencia de conducir.",
        file: "",
        status: "no enviado",
        documentType: "identificacion_oficial",
        meta: {},
      },
      {
        id: 3,
        name: "Comprobante de domicilio.",
        file: "",
        status: "no enviado",
        documentType: "comprobante_domicilio",
        meta: {},
      },
      {
        id: 4,
        name: "Comprobante de ingresos.",
        file: "",
        status: "no enviado",
        documentType: "comprobante_ingreso",
        meta: {},
      },
      {
        id: 5,
        name: "Estado de cuenta de los ultimos 6 meses.",
        file: "",
        status: "no enviado",
        documentType: "estado_cuenta",
        meta: {},
      },
      {
        id: 6,
        name: "Carta de trabajo o contrato de empleo.",
        file: "",
        status: "no enviado",
        documentType: "carta_trabajo",
        meta: {},
      },
      {
        id: 7,
        name: "Contrato.",
        file: "",
        status: "no enviado",
        documentType: "contrato",
        meta: {},
      },
    ];
  }, []);

  const chargeFile = useMemo(() => {
    // requestFile, files
    return requestFile
      .map((r) => {
        const serverFile = files?.find(
          (f) => f?.document_type === r.documentType
        );
        if (serverFile?.document_type) {
          return {
            ...r,
            status: serverFile?.status || "no enviado",
            meta: serverFile,
          };
        }

        return r;
      })
      .filter((f) => !!f?.meta?.id);
  }, [requestFile, files]);

  const fetchFiles = useCallback(async () => {
    try {
      let response;
      if (user.roles[0].name.toLowerCase() === roles.CLIENT) {
        response = await getFiles({ land_id: user.client?.lands[0]?.id });
        setFiles(response.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }, [user]);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  const actions = (file) => {
    if (file?.status === "pending" || file?.status === "rejected" || file?.status === "approved") {
      return (
        <div className="flex justify-center gap-2">
          <button
            disabled={file.status === "approved"}
            className="cursor-pointer link"
            style={{
              color: file.status === "approved" ? "gray" : "black",
            }}
            onClick={() => {
              setFileSelected(file);
              setToggleUpdateFile(true);
            }}
          >
            {t("completeProfile.update")}
          </button>
        </div>
      );
    }
  };

  return (
    <div className="p-5 DashboardSeller max-w-screen-xl pr-10">
      <div className="flex flex-row justify-start items-center w-full mt-10">
        <h3 className="title text-2xl">Usuarios</h3>
      </div>
      <div className="w-full">
        {/* Vista movil */}
        <div className="block lg:hidden">
          {_.map([{}, {}], (theUser, index) => (
            <div key={index} className="card-info">
              <div className="flex justify-between px-4">
                <div
                  className="text-sm text-black-50 hover-links"
                  onClick={() => {}}
                >
                  {theUser.name} {theUser.last_name}
                </div>
                <div>
                  {!theUser.show && <BiSolidDownArrow onClick={() => {}} />}
                  {theUser.show && <BiSolidUpArrow onClick={() => {}} />}
                </div>
              </div>
              {!theUser.show && (
                <div>
                  <div className="grid grid-cols-2 gap-4 my-2">
                    <div className="field-title text-black-50">Documentos</div>
                    <div className="text-left field-value text-black-50">
                      Lorem ipsum dolor sit amets
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 my-2">
                    <div className="field-title"></div>
                    <div className="text-left field-value text-black-50">
                      <EyesIcon size={20} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 my-2">
                    <div className="field-title"></div>
                    <div className="text-left field-value text-black-50">
                      <Download size={20} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* vista web */}
        <>
          <Card className="mt-5 rounded-md">
            <table className="w-full">
              <thead className="bg-[#F8F9FB]">
                <tr>
                  <td className="p-2">{t("completeProfile.document")}</td>
                  <td className="p-2"></td>
                  <td className="p-2"></td>
                  <td className="p-2"></td>
                </tr>
              </thead>
              <tbody>
                {chargeFile?.map((f, i) => (
                  <tr
                    key={i}
                    className={i % 2 === 0 ? "" : "bg-[#F8F9FB]"}
                    style={{ alignItems: "center" }}
                  >
                    <td
                      className="p-2 content-center w-full"
                      style={{ fontSize: 12 }}
                    >
                      <p
                        style={{
                          color: "#000",
                        }}
                      >
                        {f.name}
                      </p>
                    </td>
                    <td className="p-2 content-center">
                      <td className="content-center">
                        <div
                          className="cursor-pointer link"
                          onClick={() => {
                            if (!f?.meta?.document_type) {
                              return;
                            }
                            setFileSelected(f?.meta);
                            setShowFile(true);
                          }}
                        >
                          Previsualizar
                        </div>
                      </td>
                    </td>
                    <td
                      className="p-2 content-center"
                      style={{ color: !f?.meta?.document_type && "#BFBFBF" }}
                    >
                      {/*statusHandler(f?.meta)*/}
                      <div className="cursor-pointer link">
                        <a href={f?.meta?.file_path} download="document.pdf">
                          <Download size={20} />
                        </a>
                      </div>
                    </td>
                    <td className="p-2 pr-5 content-center">
                      {actions(f?.meta)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
          {toggleUpdateFile && (
            <Modal
              type="small"
              onCloseModal={() => setToggleUpdateFile(false)}
              title="Actualizar documento"
              style={{ height: 280 }}
              iconColor="#F45D85"
            >
              <>
                <UpdateFile file={fileSelected} />
              </>
            </Modal>
          )}
          {showFile && (
            <Modal type="large" onCloseModal={() => setShowFile(false)}>
              <>
                <ShowFile file={fileSelected} hideButtons={false} />
              </>
            </Modal>
          )}
        </>
        <div className="flex justify-center w-full mt-4 mb-4">
          <Pagination meta={[]} onPageSelected={() => {}} />
        </div>
      </div>
    </div>
  );
};

export default UserPayments;
